import React from "react";
import { useLocation } from "@reach/router";
import { areasArray } from "../../locations";
import { useI18nL10nContext} from "gatsby-plugin-i18n-l10n";


import "./languageSwitcher.css";

export default function LanguageSwitcher(){
  const languageContext = useI18nL10nContext();
  
  const location = useLocation();
  // console.log("languageContext: ",languageContext);
  const city:string = areasArray.filter((area)=>location.href?.includes(area.link))[0]?.link;
  const newPath:string | undefined = languageContext.translations?.filter((path)=>path.path?.includes(city))[0]?.path;
  const label = newPath?.includes(`${city}en`)?"English":"Francais";

  //console.log("newPath: ",newPath);
  
  return(
     <>
     {areasArray.some((area: any) => location.href?.includes(area.link))?
       <div className="selectLanguage">
       <a href={newPath || "/"}>{label}</a>
       {/* <a href={newPath || "/"}>{label}</a> */}
     </div>
       :
       <></>
     }
   </>
)};